import { StyledContainer, StyledTextLabel } from './SectionHeading.styled';

interface ISectionHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
	icon: string;
	text: string;
}

const SectionHeading: React.FC<ISectionHeadingProps> = ({
	icon,
	text,
}: ISectionHeadingProps) => {
	return (
		<StyledContainer>
			<img src={icon} style={{ opacity: 0.75 }} />
			<StyledTextLabel>{text}</StyledTextLabel>
		</StyledContainer>
	);
};

export { SectionHeading };
